import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { XIcon } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import UserForm from './UserForm';


class EditUserModal  extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };

        this.initialValues = {};
    }
    submit = ( values ) => {
        this.setState( { fetching: true } );
        var data = { ...values };
        var updates = { affil: [] };

        //parse out subaffiliate ids for updating independentaly
        if( data.amazonsubaffiliateid != this.initialValues.amazonsubaffiliateid ) {
            updates.affil.push( {
                userid: data.userid,
                affiliateid: 1,
                subAffiliateCode: values.amazonsubaffiliateid || null,
            } );
        }
        delete data.amazonsubaffiliateid;
        if( data.commisionsubaffiliateid != this.initialValues.commisionsubaffiliateid ) {
            updates.affil.push( {
                userid: data.userid,
                affiliateid: 2,
                subAffiliateCode: values.commisionsubaffiliateid || null,
            } );
        }
        delete data.commisionsubaffiliateid;
        if( data.rakutensubaffiliateid != this.initialValues.rakutensubaffiliateid ) {
            updates.affil.push( {
                userid: data.userid,
                affiliateid: 3,
                subAffiliateCode: values.rakutensubaffiliateid || null,
            } );
        }
        delete data.rakutensubaffiliateid;
        if( data.targetSubaffiliateId != this.initialValues.targetSubaffiliateId ) {
            updates.affil.push( {
                userid: data.userid,
                affiliateid: 4,
                subAffiliateCode: values.targetSubaffiliateId || null,
            } );
        }
        delete data.targetSubaffiliateId;
        delete data.affiliateCodes;

        //if the user is being upgraded, reset their pending and tutorial status
        if( values.usertype !== this.initialValues.usertype && values.usertype == 'verified creator' ) {
            data.curatorPending = false;
            data.tutorialComplete = false;
        }

        //handle featured toggle
        data.featured = !data.featured ? false : this.initialValues.featured ? undefined : true;
        //convert category objects down into IDs for the API

        data.interests = data.interestIds;
        
        updates.user = data;
        return Promise.resolve( this.props.onSubmit && this.props.onSubmit( updates ) )
        .then( () => {
            if( data.usertype !== this.initialValues.usertype && data.usertype == 'verified creator' ) {
                Mixpanel.track( 'accountUpgraded', {
                    id: data.userid,
                    name: data.displayName,
                    email: data.emailAddress,
                    facebook_token: data.facebookid,
                    verified_curator: data.usertype == 'verified creator',
                    admin: data.usertype == 'admin',
                    gender: data.gender,
                    slug: data.slug,
                    date_created: data.dateCreated,
                    active: !data.deactivated,
                } );
            }
            this.setState( { fetching: false } );
            this.props.closeModal();
        } );
    }
    render() {
        const { modalName, modalProps, user } = this.props;
        let goodToGo = false;
        if ( modalName === 'editUserModal' ) {
            goodToGo = true;
        }
        if( !user.userid ) {
            return (
                <ReactModal
                isOpen={ modalProps.modalIsOpen && goodToGo }
                contentLabel="Edit User"
                onRequestClose={ this.props.closeModal }
                className='modal-popup'
                overlayClassName='modal-overlay' >
                    <div className='modal-title'>
                        <h2>Edit User</h2>
                    </div>
                    <div className='close-button' onClick={ this.props.closeModal }>
                        <XIcon size={ 24 } />
                    </div>
                    <div>
                        <LoadingOverlay />
                    </div>
                </ReactModal>
            );
        }
        var initialValues = {
            ...this.props.user,
            interestIds: ( this.props.user.interests || [] ).map( interest => interest.interestid ),
        };
        if(typeof this.props.user.affiliates == 'undefined') {
            this.props.user.affiliates = [];
        }
        
        for( var i = 0; i < this.props.user.affiliates.length; i++ ) {
            
            let _aff;
            if(this.props.user.affiliates[ i ].UserAffiliate) {
                _aff = user.affiliates[i].UserAffiliate;
            } else {
                _aff = user.affiliates[i];
            }
            
            if( this.props.user.affiliates[i].affiliateid == 1 ) {
                initialValues.amazonsubaffiliateid = _aff.subAffiliateCode;
                continue;
            }
            if( this.props.user.affiliates[i].affiliateid == 2 ) {
                initialValues.commisionsubaffiliateid = _aff.subAffiliateCode;
                continue;
            }
            if( this.props.user.affiliates[i].affiliateid == 3 ) {
                initialValues.rakutensubaffiliateid = _aff.subAffiliateCode;
                continue;
            }
            if( this.props.user.affiliates[i].affiliateid == 4 ) {
                initialValues.targetSubaffiliateId = _aff.subAffiliateCode;
                continue;
            }
        }
        this.initialValues = { ...initialValues };
        return (
            <ReactModal
            isOpen={ modalProps.modalIsOpen && goodToGo }
            contentLabel="Edit User"
            onRequestClose={ this.props.closeModal }
            className='modal-popup'
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>Edit User</h2>
                </div>
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <div>
                    <UserForm submitHandler={ this.submit } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};

export default connect( mapStateToProps, null )( EditUserModal );
